module.exports = __webpack_public_path__ + "static/media/flag-en.0eb3abb3.svg";